<template>
	<div>
		<small>{{ i18n.sideSelection.explanation }}</small>
		<br />
		<SideToggle
			:value="sideSelection"
			name="measurements[side_selection]"
			idPrefix="measurements-side-selection"
			@input="(value) => updateSideSelection(value)"
		/>
	</div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import SideToggle from "@/components/SideToggle";

export default {
	components: { SideToggle },
	computed: {
		i18n() { return this.$i18n; },
		...mapGetters( [
			'sideSelection',
		] ),
	},
	methods: {
		...mapMutations( [
			'updateSideSelection',
		] ),
	},
};
</script>
